import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { downloadFile } from '../../../lib/download-file';
import { OnGetData } from '../../../services/dialog.service';
import { QrCodeComponent } from '../../../shared/components/qr-code/qr-code.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, QrCodeComponent],
})
export class QrCodeDialogComponent implements OnGetData {
  dialogName = 'qr-code';
  close: (...args) => void;
  content: string;
  loading = true;
  @ViewChild('qrCode') qrCode: QrCodeComponent;

  dialogOptions(): DialogOptions {
    return { size: 560 };
  }

  async onGetData(data: { content: string }, close: (...args) => void) {
    this.close = close;
    this.content = data.content;
  }

  downloadQrCode() {
    downloadFile(this.qrCode.dataUrl(), 'qr-code.jpg');
  }
}
